import { render, staticRenderFns } from "./BarHorizontalChart.vue?vue&type=template&id=7d2b9e5b"
import script from "./BarHorizontalChart.vue?vue&type=script&lang=js"
export * from "./BarHorizontalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d2b9e5b')) {
      api.createRecord('7d2b9e5b', component.options)
    } else {
      api.reload('7d2b9e5b', component.options)
    }
    module.hot.accept("./BarHorizontalChart.vue?vue&type=template&id=7d2b9e5b", function () {
      api.rerender('7d2b9e5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/BarHorizontalChart.vue"
export default component.exports